import { render, staticRenderFns } from "./GenerateToken.vue?vue&type=template&id=be354e40"
import script from "./GenerateToken.vue?vue&type=script&lang=js"
export * from "./GenerateToken.vue?vue&type=script&lang=js"
import style0 from "./GenerateToken.vue?vue&type=style&index=0&id=be354e40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports